import { z } from "zod";
export const slackGatewayReplyInputSchema = z.object({
    idempotencyKey: z.string().trim().min(1).max(200),
    threadId: z.string().trim().min(1).max(1_024),
    taskId: z.string().trim().min(1).max(128),
    runId: z.string().trim().min(1).max(128),
    sessionId: z.string().trim().min(1).max(128),
    sessionUrl: z.string().trim().url(),
    status: z.enum(["completed", "failed"]),
    outputText: z.string().optional(),
    errorMessage: z.string().optional(),
}).strict();
export const slackGatewayReplyResponseSchema = z.object({
    ok: z.literal(true),
    providerMessageId: z.string().trim().min(1).max(1_024),
}).strict();
